import { generateOpenApi } from '@ts-rest/open-api';
import { locationsContract } from './locations.contract.js';

export const locationsOpenApiSpec = generateOpenApi(
  locationsContract,
  {
    info: {
      title: 'Skewb Works Locations API',
      version: '1.0.0',
      description:
        'Type-safe locations API for Skewb Works Lite. Covers regions, areas, and their ' +
        'normalised postcode lists. The areas list returns a bounded postcode preview per ' +
        'area (an area can hold tens of thousands of postcodes); fetch the complete list via ' +
        'GET /areas/:id.',
      contact: {
        name: 'Skewb Works Development Team',
      },
    },
    servers: [
      {
        url: 'https://localhost:8080',
        description: 'Local development server',
      },
      {
        url: 'https://api.works-works-lite.dev.skewbdigital.co.uk',
        description: 'Dev API server',
      },
    ],
    tags: [
      {
        name: 'Locations',
        description: 'Region, area, and area-postcode management endpoints',
      },
    ],
  },
  {
    setOperationId: true,
    operationMapper: (operation) => ({
      ...operation,
      tags: ['Locations'],
    }),
  },
);
